import * as XLSX from 'xlsx';

/**
 * Скачивает данные в формате Excel (.xlsx)
 * @param {string} filename — имя файла без расширения или с .xlsx
 * @param {string} sheetName — название листа
 * @param {string[]} headers — заголовки колонок
 * @param {Array<Array<string|number>>} rows — строки данных
 */
export const downloadExcel = (filename, sheetName, headers, rows) => {
  const data = [headers, ...rows];
  const worksheet = XLSX.utils.aoa_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31) || 'Sheet1');
  const safeName = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  XLSX.writeFile(workbook, safeName);
};
